import {Grid} from "@mui/system";
import {Checkbox, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "../Dialogos/Dialogo_Politicas";


export const usePoliticas = ({politica}) => {
    const [value, setValue] = useState(false);
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})


    const Politica = ({datos}) => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={1} sx={{justifyContent: 'flex-start'}}>
                    <Checkbox
                        color={'secondary'}
                        sx={{p: 0, borderColor: '#fff', color: '#fff'}}
                        checked={value}
                        onChange={(e) => setValue(e.target.checked)}/>
                </Grid>

                <Grid container size={11} sx={{justifyContent: 'flex-start', pl: 1}}>
                    <Typography sx={{color: '#fff', fontSize: 14, lineHeight: 1.1}}>{politica}
                        <span
                            onClick={() => abrir(datos)}
                            style={{
                                color: theme.palette.primary.main,
                                textDecoration: 'underline',
                                marginLeft: 5,
                                cursor: 'pointer',

                            }}>Ver</span> </Typography>
                </Grid>

                <Dialogo/>

            </Grid>
        )
    }

    return {

        Politica,
        value
    }
}